import React from 'react';
import { CoreContainer } from '@hub/core-container';
import { Box } from '@hub/box';
import { makeUnscaledImageUrl } from '../cloudinary-image/helpers/make-image-url';
import trackClickEvents, { categories, labels } from '../analytics/trackEvents';
import { jsx as _jsx } from "react/jsx-runtime";
export { default as getTopStripProps } from './get-top-strip-props';
export { default as useTopStripProps } from './use-top-strip-props';
export { default as useIsTopStripEnabled } from './use-is-top-strip-enabled';

const TopStrip = _ref => {
  let {
    backgroundImage,
    backgroundColour: backgroundColor,
    foregroundImage,
    shortDescription,
    actionText,
    url
  } = _ref;
  return /*#__PURE__*/_jsx(Box, {
    as: "a",
    href: url,
    sx: {
      display: 'block',
      backgroundColor,
      backgroundImage: backgroundImage ? makeUnscaledImageUrl(backgroundImage) : undefined,
      backgroundSize: 'auto var(--chakra-sizes-size-xs)',
      backgroundRepeat: 'repeat',
      backgroundPositionX: 'left'
    },
    title: actionText,
    onClick: () => trackClickEvents.clicked(categories.UNIVERSAL_HEADER, labels.BENEFITS_STRIP),
    "data-id": "top-strip_index_TopStrip_Box",
    children: /*#__PURE__*/_jsx(CoreContainer, {
      sx: {
        position: 'relative',
        height: 'size-xs'
      },
      "data-id": "top-strip_index_TopStrip_Box_CoreContainer",
      children: /*#__PURE__*/_jsx("img", {
        src: makeUnscaledImageUrl(foregroundImage),
        alt: shortDescription,
        style: {
          margin: '0 auto',
          height: 'var(--chakra-sizes-size-xs)'
        },
        "data-id": "top-strip_index_TopStrip_CoreContainer_img"
      })
    })
  });
};

export default TopStrip;